import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=2bbc8d10&scoped=true"
import script from "./Browse.vue?vue&type=script&lang=js"
export * from "./Browse.vue?vue&type=script&lang=js"
import style0 from "./Browse.vue?vue&type=style&index=0&id=2bbc8d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc8d10",
  null
  
)

export default component.exports